import { newE2EPage } from '@stencil/core/testing';

describe('salla-social', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<salla-social></salla-social>');

    const element = await page.find('salla-social');
    expect(element).toHaveClass('hydrated');
  });
});
